import React from 'react';

const IconLock: React.FC<JSX.IntrinsicElements['svg']> = (props) => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.84998 7.09998C5.43588 7.09998 5.09998 7.43521 5.09998 7.84998C5.09998 8.26474 5.43588 8.59998 5.84998 8.59998C6.2649 8.59998 6.59998 8.2649 6.59998 7.84998C6.59998 7.43505 6.2649 7.09998 5.84998 7.09998ZM4.59998 7.84998C4.59998 7.15874 5.16007 6.59998 5.84998 6.59998C6.54105 6.59998 7.09998 7.1589 7.09998 7.84998C7.09998 8.54105 6.54105 9.09998 5.84998 9.09998C5.16007 9.09998 4.59998 8.54121 4.59998 7.84998Z"
      fill="#ED0B24"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.5 6.70714C1.5 5.4838 2.50399 4.5 3.73235 4.5H7.96765C9.19601 4.5 10.2 5.4838 10.2 6.70714V9.49286C10.2 10.7162 9.19601 11.7 7.96765 11.7H3.73235C2.50399 11.7 1.5 10.7162 1.5 9.49286V6.70714ZM3.73235 5.2C2.88166 5.2 2.2 5.87927 2.2 6.70714V9.49286C2.2 10.3207 2.88166 11 3.73235 11H7.96765C8.81834 11 9.5 10.3207 9.5 9.49286V6.70714C9.5 5.87927 8.81834 5.2 7.96765 5.2H3.73235Z"
      fill="#ED0B24"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.85 1.2C4.65535 1.2 3.7 2.14494 3.7 3.29444V4.5H8V3.29444C8 2.14494 7.04465 1.2 5.85 1.2ZM3 3.29444C3 1.74351 4.28374 0.5 5.85 0.5C7.41626 0.5 8.7 1.74351 8.7 3.29444V4.85C8.7 5.0433 8.5433 5.2 8.35 5.2H3.35C3.1567 5.2 3 5.0433 3 4.85V3.29444Z"
      fill="#ED0B24"
    />
  </svg>
);

export default IconLock;
